import { ɵɵinject, ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, ɵɵnextContext, ɵɵadvance, ɵɵtextInterpolate1, ɵɵgetCurrentView, ɵɵelementContainerStart, ɵɵlistener, ɵɵrestoreView, ɵɵelement, ɵɵpipe, ɵɵtemplate, ɵɵelementContainerEnd, ɵɵclassProp, ɵɵproperty, ɵɵpipeBind1, ɵɵsanitizeHtml, EventEmitter, ɵɵdirectiveInject, ɵɵdefineComponent, Component, Output, Input, ɵɵelementContainer, ɵɵpureFunction2, ɵɵattribute, ɵɵpureFunction1, ɵɵdefineDirective, Directive, ɵɵcontentQuery, TemplateRef, ɵɵqueryRefresh, ɵɵloadQuery, ContentChildren, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LocalService } from '@akeela/local-storage';
import { AuthService } from '@akeela/auth';
import { HttpService, PathService } from '@akeela/properties';
import { RouteUtilsService } from '@akeela/workflow';
import { FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { NgIf, NgForOf, NgTemplateOutlet, NgClass, CommonModule } from '@angular/common';
import { CommonService } from '@akeela/common';
import { I18nPipe, I18nModule } from '@akeela/i18n';

class AkeelaSidebarMenuService {
    constructor(http, localStorage) {
        this.http = http;
        this.localStorage = localStorage;
        this.showSidebarLeft$ = new BehaviorSubject(false);
        this.sidebarLeftKey$ = new BehaviorSubject(null);
        this.sidebarLeftOptions$ = new BehaviorSubject({});
        this.showSidebarTop$ = new BehaviorSubject(false);
        this.sidebarTopKey$ = new BehaviorSubject(null);
        this.sidebarTopOptions$ = new BehaviorSubject({});
        this.counterQueues$ = new BehaviorSubject({});
        this.sidebarTopActive$ = new BehaviorSubject(null);
        this.sidebarLeftActive$ = new BehaviorSubject(null);
        this.sidebarSubLeftActive$ = new BehaviorSubject(null);
        this.sidebarSubTopActive$ = new BehaviorSubject(null);
        this.updateQueues$ = new BehaviorSubject(null);
    }
    setSidebarTopActive(data) {
        this.sidebarTopActive$.next(data);
        if (data) {
            this.localStorage.setItem('sidebarTopActive', data.sidebarTopActive ? data.sidebarTopActive : '');
            this.localStorage.setItem('sidebar2TopActive', data.sidebar2TopActive ? data.sidebar2TopActive : '');
        }
    }
    setSidebarSubTopActive(sidebarSubTopActive) {
        this.sidebarSubTopActive$.next(sidebarSubTopActive);
        this.localStorage.setItem('sidebarSubTopActive', sidebarSubTopActive);
    }
    setSidebarLeftActive(sidebarLeftActive) {
        this.sidebarLeftActive$.next(sidebarLeftActive);
        this.localStorage.setItem('sidebarLeftActive', sidebarLeftActive);
    }
    setSidebarSubLeftActive(sidebarSubLeftActive) {
        this.sidebarSubLeftActive$.next(sidebarSubLeftActive);
        this.localStorage.setItem('sidebarSubLeftActive', sidebarSubLeftActive);
    }
    setshowSidebarLeft(showSidebarLeft) {
        this.localStorage.setItem('showSidebarLeft', showSidebarLeft ? 'true' : 'false');
        this.showSidebarLeft$.next(showSidebarLeft);
    }
    setCounterQueues(counterQueues) {
        this.counterQueues$.next(counterQueues);
    }
    get showSidebarLeft() {
        return this.showSidebarLeft$;
    }
    setsidebarLeftKey(sidebarLeftKey) {
        this.sidebarLeftKey$.next(sidebarLeftKey);
    }
    get sidebarLeftKey() {
        return this.sidebarLeftKey$;
    }
    setsidebarLeftOptions(sidebarLeftOptions) {
        this.sidebarLeftOptions$.next(sidebarLeftOptions);
    }
    get sidebarLeftOptions() {
        return this.sidebarLeftOptions$;
    }
    //**top */
    setshowSidebarTop(showSidebarTop) {
        this.localStorage.setItem('showSidebarTop', showSidebarTop ? 'true' : 'false');
        this.showSidebarTop$.next(showSidebarTop);
    }
    get showSidebarTop() {
        return this.showSidebarTop$;
    }
    setsidebarTopKey(sidebarTopKey) {
        this.sidebarTopKey$.next(sidebarTopKey);
    }
    get sidebarTopKey() {
        return this.sidebarTopKey$;
    }
    setsidebarTopOptions(sidebarTopOptions) {
        this.sidebarTopOptions$.next(sidebarTopOptions);
    }
    get sidebarTopOptions() {
        return this.sidebarTopOptions$;
    }
    setUpdateQueues() {
        this.updateQueues$.next(true);
    }
    get updateQueues() {
        return this.updateQueues$;
    }
}
/** @nocollapse */ AkeelaSidebarMenuService.ɵfac = function AkeelaSidebarMenuService_Factory(t) { return new (t || AkeelaSidebarMenuService)(ɵɵinject(HttpClient), ɵɵinject(LocalService)); };
/** @nocollapse */ AkeelaSidebarMenuService.ɵprov = ɵɵdefineInjectable({ token: AkeelaSidebarMenuService, factory: AkeelaSidebarMenuService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaSidebarMenuService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: LocalService }]; }, null); })();

class AkeelaTemplateService {
    constructor() {
        this.templates = {};
    }
    addTemplate(componentName, template) {
        this.templates[componentName] = template;
    }
    getTemplates() {
        return this.templates;
    }
    getTemplate(componentName) {
        return this.templates[componentName];
    }
}
/** @nocollapse */ AkeelaTemplateService.ɵfac = function AkeelaTemplateService_Factory(t) { return new (t || AkeelaTemplateService)(); };
/** @nocollapse */ AkeelaTemplateService.ɵprov = ɵɵdefineInjectable({ token: AkeelaTemplateService, factory: AkeelaTemplateService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaTemplateService, [{
        type: Injectable
    }], function () { return []; }, null); })();

function ListQueues_ng_container_1_ng_container_1_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1, " ( ");
    ɵɵelementStart(2, "span", 6);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵtext(4, " )");
    ɵɵelementEnd();
} if (rf & 2) {
    const lst_r3 = ɵɵnextContext().$implicit;
    const ctx_r4 = ɵɵnextContext(2);
    ɵɵadvance(3);
    ɵɵtextInterpolate1(" ", ctx_r4.getCounterQueues(lst_r3 == null ? null : lst_r3.alternateName), "");
} }
function ListQueues_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 3);
    ɵɵlistener("click", function ListQueues_ng_container_1_ng_container_1_Template_div_click_1_listener() { ɵɵrestoreView(_r7); const lst_r3 = ctx.$implicit; const ctx_r6 = ɵɵnextContext(2); return ctx_r6.processLink(lst_r3); });
    ɵɵelementStart(2, "a", 4);
    ɵɵelement(3, "span", 5);
    ɵɵpipe(4, "i18n");
    ɵɵtemplate(5, ListQueues_ng_container_1_ng_container_1_span_5_Template, 5, 1, "span", 1);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const lst_r3 = ctx.$implicit;
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵclassProp("active", lst_r3.alternateName == ctx_r2.sidebarSubLeftActive);
    ɵɵadvance(2);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(4, 4, lst_r3.name), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r2.getCounterQueues(lst_r3 == null ? null : lst_r3.alternateName) > 0);
} }
function ListQueues_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, ListQueues_ng_container_1_ng_container_1_Template, 6, 6, "ng-container", 2);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r0.optionsQueues);
} }
function ListQueues_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 7);
    ɵɵelement(2, "img", 8);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} }
class ListQueues {
    constructor(route, router, formBuilder, _sanitizer, _httpService, _akeelaSidebarMenu, _auth, _path, routeService, templateService, _common, localStorage) {
        this.route = route;
        this.router = router;
        this.formBuilder = formBuilder;
        this._sanitizer = _sanitizer;
        this._httpService = _httpService;
        this._akeelaSidebarMenu = _akeelaSidebarMenu;
        this._auth = _auth;
        this._path = _path;
        this.routeService = routeService;
        this.templateService = templateService;
        this._common = _common;
        this.localStorage = localStorage;
        this.response = new EventEmitter();
        this.enabledQueue = new EventEmitter();
        this.sidebarLeftOptions = {};
        this.optionsQueues = [];
        this.queryParams = {};
        this.templates = {};
        this.isAuth = false;
        this.counterQueues = {};
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.templates = this.templateService.getTemplates();
        }, 10);
    }
    ngOnInit() {
        this._auth.isAuth$.subscribe((isAuth) => {
            if (isAuth != this.isAuth) {
                if (!isAuth) {
                    if (this.isAuth) {
                        this.isAuth = isAuth;
                        // this.redirect(this.ulrLogout,{});
                        this._akeelaSidebarMenu.setshowSidebarLeft(false);
                        this._akeelaSidebarMenu.counterQueues$.subscribe((counterQueues) => {
                            this.counterQueues = counterQueues;
                        });
                        location.reload();
                    }
                    else {
                        this.isAuth = isAuth;
                    }
                }
                else {
                    this.isAuth = isAuth;
                }
            }
        });
        this._akeelaSidebarMenu.updateQueues$.subscribe(response => {
            if (!isNullOrUndefined(response)) {
                this.getQueues();
            }
        });
        this._akeelaSidebarMenu.sidebarSubLeftActive$.subscribe((sidebarSubLeftActive) => {
            this.sidebarSubLeftActive = sidebarSubLeftActive;
        });
        if (this.localStorage.getItem('workspace')) {
            this.workspaceCode = this.localStorage.getItem('workspace');
            this.getQueues();
        }
        this._common.workspaceCode$.subscribe((workspaceCode) => {
            if (!isNullOrUndefined(workspaceCode)) {
                this.enabledQueue.emit(true);
                this.workspaceCode = workspaceCode;
                this.getQueues();
            }
            else {
                this.optionsQueues = [];
                this.counterQueues = [];
                this.enabledQueue.emit(false);
            }
        });
    }
    getQueues() {
        this.counterQueues = [];
        this.username = this._auth.getUsername();
        if (!isNullOrUndefined(this.functionLink)) {
            this.loading = true;
            this._path.getPathService(false, this.functionLink).subscribe(response => {
                if (!isNullOrUndefined(response)) {
                    let paramsData = this._path.getAdditionalType(this, response.additionalType);
                    let params = {
                        configuration: {
                            name: response.name,
                            params: paramsData.params
                        }
                    };
                    this.subscriptor_queues_menu = this._httpService.executeRequest(params.configuration.name, params.configuration.params, true).subscribe((params) => {
                        var _a, _b;
                        let temp = [];
                        for (let category of Object.keys(params)) {
                            for (let element of Object.keys((_a = params[category]) === null || _a === void 0 ? void 0 : _a.queues)) {
                                temp = [...temp, (_b = params[category]) === null || _b === void 0 ? void 0 : _b.queues[element]];
                            }
                        }
                        ;
                        for (let element of Object.keys(temp)) {
                            this.counterQueues[temp[element].alternateName] = temp[element].additionalType;
                        }
                        ;
                        this._akeelaSidebarMenu.setCounterQueues(this.counterQueues);
                        this.optionsQueues = temp;
                        this.loading = false;
                    }, (error) => {
                        this.loading = false;
                    });
                }
            }, (error) => {
                this.loading = false;
            });
        }
    }
    getCounterQueues(param) {
        return this.counterQueues[param];
    }
    processLink(data) {
        this.sidebarSubLeftActive = data.alternateName;
        this._akeelaSidebarMenu.setSidebarSubLeftActive(this.sidebarSubLeftActive);
        this.dataproceslink = {};
        this.dataproceslink = data;
        this.codeQueue = this.dataproceslink.alternateName;
        this.role = this.localStorage.getItem('role');
        this.profile = this.localStorage.getItem('profile');
        this.audience = this.localStorage.getItem('audience');
        const url = '';
        const request = {};
        if (this.dataproceslink.description) {
            this.subscriptor_menu_click = this._httpService.executeFrontRequest(this, this.dataproceslink.description, true).subscribe((response) => {
                if (!isNullOrUndefined(response)) {
                    this.response.emit({
                        action: 'navigate',
                        url: response.url
                    });
                    this.redirect(response.url, response.request);
                }
            });
        }
        else if (this.dataproceslink.functionLink) {
        }
        else if (this.dataproceslink.url) {
            this.response.emit({
                action: 'navigate',
                url: url
            });
            this.redirect(url, request);
        }
    }
    redirect(url, request) {
        const queryParams = request;
        this.router.navigate([url], { queryParams });
    }
    ngOnDestroy() {
        if (this.subscriptor_queues_menu) {
            this.subscriptor_queues_menu.unsubscribe();
        }
        if (this.subscriptor_menu_click) {
            this.subscriptor_menu_click.unsubscribe();
        }
    }
}
/** @nocollapse */ ListQueues.ɵfac = function ListQueues_Factory(t) { return new (t || ListQueues)(ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(DomSanitizer), ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(AkeelaSidebarMenuService), ɵɵdirectiveInject(AuthService), ɵɵdirectiveInject(PathService), ɵɵdirectiveInject(RouteUtilsService), ɵɵdirectiveInject(AkeelaTemplateService), ɵɵdirectiveInject(CommonService), ɵɵdirectiveInject(LocalService)); };
/** @nocollapse */ ListQueues.ɵcmp = ɵɵdefineComponent({ type: ListQueues, selectors: [["list-queues"]], inputs: { functionLink: "functionLink" }, outputs: { response: "response", enabledQueue: "enabledQueue" }, decls: 3, vars: 2, consts: [[1, "sidebar", "mb-2"], [4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "dd-link", "cursor-pounter", "curs", 3, "click"], ["href", "javascript:void(0)"], [3, "innerHTML"], [1, "font-weight-bold"], [1, "row"], ["src", "./assets/public/images/loading.gif", "alt", " "]], template: function ListQueues_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵtemplate(1, ListQueues_ng_container_1_Template, 2, 1, "ng-container", 1);
        ɵɵtemplate(2, ListQueues_ng_container_2_Template, 3, 0, "ng-container", 1);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.optionsQueues);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.loading);
    } }, directives: [NgIf, NgForOf], pipes: [I18nPipe], styles: ["[_nghost-%COMP%]{--ak-menu-left-dd-link-colas:#444!important;--ak-menu-left-dd-link-colas-bg:#fff!important;--ak-menu-left-dd-link-hover-colas:#666;--ak-menu-left-dd-link-hover-colas-bg:#fff}.sidebar[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{cursor:pointer;text-decoration:none}.sidebar[_ngcontent-%COMP%]   .m-l-title[_ngcontent-%COMP%]{font-weight:700}.sidebar[_ngcontent-%COMP%]   .m-l-subTitle[_ngcontent-%COMP%]{color:#777!important;font-size:16px;font-weight:700}.sidebar[_ngcontent-%COMP%]   .cerrar[_ngcontent-%COMP%]{color:#777;font-size:20px;margin:8px 8px 0}.sidebar[_ngcontent-%COMP%]   .cerrar[_ngcontent-%COMP%]:HOVER{color:#aaa}.sidebar[_ngcontent-%COMP%]   .head[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{margin-top:1rem}.sidebar[_ngcontent-%COMP%]   .icon-dropdown[_ngcontent-%COMP%]{font-size:24px}.sidebar[_ngcontent-%COMP%]   .dd-link[_ngcontent-%COMP%]{font-size:14px;margin-left:28px;padding:5px 0}.sidebar[_ngcontent-%COMP%]   .dd-link.active[_ngcontent-%COMP%], .sidebar[_ngcontent-%COMP%]   .dd-link[_ngcontent-%COMP%]:hover{margin-left:19px}.sidebar[_ngcontent-%COMP%]   .dd-link[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{background:var(--ak-menu-left-dd-link-colas-bg);color:var(--ak-menu-left-dd-link-colas)}.sidebar[_ngcontent-%COMP%]   .dd-link.active[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .sidebar[_ngcontent-%COMP%]   .dd-link[_ngcontent-%COMP%]:hover   a[_ngcontent-%COMP%]{background:var(--ak-menu-left-dd-link-hover-colas-bg)!important;border-radius:7px;color:var(--ak-menu-left-dd-link-hover-colas)!important;padding:5px 9px}.sidebar[_ngcontent-%COMP%]   .title-sidebar[_ngcontent-%COMP%]{border-bottom:.5px solid #aaa;border-top:.5px solid #aaa}.sidebar[_ngcontent-%COMP%]   .dd-link2[_ngcontent-%COMP%]{padding:3px 0}.m-t-12[_ngcontent-%COMP%]{margin-top:23px}.sidebar[_ngcontent-%COMP%]::-webkit-scrollbar{border-radius:50px;height:5px!important;width:5px!important}.pt-img[_ngcontent-%COMP%]{padding-left:15px;padding-top:16px;text-align:left}.icon-menu[_ngcontent-%COMP%]{font-size:1.2rem;margin-right:.8rem}.sub-menu[_ngcontent-%COMP%]{margin-bottom:.7rem;margin-left:2.4rem}@media (max-width:768px){.sidebar[_ngcontent-%COMP%], .sidebar[_ngcontent-%COMP%]   .dd-link[_ngcontent-%COMP%]{font-size:16px}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ListQueues, [{
        type: Component,
        args: [{
                selector: 'list-queues',
                templateUrl: './list-queues.component.html',
                styleUrls: ['./list-queues.component.css']
            }]
    }], function () { return [{ type: ActivatedRoute }, { type: Router }, { type: FormBuilder }, { type: DomSanitizer }, { type: HttpService }, { type: AkeelaSidebarMenuService }, { type: AuthService }, { type: PathService }, { type: RouteUtilsService }, { type: AkeelaTemplateService }, { type: CommonService }, { type: LocalService }]; }, { response: [{
            type: Output
        }], enabledQueue: [{
            type: Output
        }], functionLink: [{
            type: Input
        }] }); })();

function SidebarLeft_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function SidebarLeft_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function SidebarLeft_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 6);
    ɵɵelement(2, "img", 7);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} }
function SidebarLeft_ng_container_6_ng_container_1_ng_container_1_hr_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "hr", 14);
} }
function SidebarLeft_ng_container_6_ng_container_1_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 15);
    ɵɵtext(1, "Solicitudes");
    ɵɵelementEnd();
} }
function SidebarLeft_ng_container_6_ng_container_1_ng_container_1_div_3_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 21);
} }
function SidebarLeft_ng_container_6_ng_container_1_ng_container_1_div_3_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 22);
} }
const _c0 = function (a0, a1) { return { "font-weight-bold": a0, "disabled": a1 }; };
function SidebarLeft_ng_container_6_ng_container_1_ng_container_1_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 16);
    ɵɵlistener("click", function SidebarLeft_ng_container_6_ng_container_1_ng_container_1_div_3_Template_div_click_0_listener() { ɵɵrestoreView(_r17); const lst_r6 = ɵɵnextContext(2).$implicit; const ctx_r15 = ɵɵnextContext(2); return ctx_r15.processLink(lst_r6); });
    ɵɵelementStart(1, "a", 17);
    ɵɵtemplate(2, SidebarLeft_ng_container_6_ng_container_1_ng_container_1_div_3_i_2_Template, 1, 0, "i", 18);
    ɵɵtemplate(3, SidebarLeft_ng_container_6_ng_container_1_ng_container_1_div_3_i_3_Template, 1, 0, "i", 19);
    ɵɵelement(4, "span", 20);
    ɵɵpipe(5, "i18n");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const lst_r6 = ɵɵnextContext(2).$implicit;
    const ctx_r11 = ɵɵnextContext(2);
    ɵɵclassProp("active", lst_r6.name == ctx_r11.sidebarLeftActive && !(lst_r6.functionLink && ctx_r11.enabledQueue));
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ɵɵpureFunction2(9, _c0, lst_r6.functionLink, lst_r6 == null ? null : lst_r6.disabled));
    ɵɵattribute("disabled", lst_r6 == null ? null : lst_r6.disabled);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", lst_r6.functionLink && ctx_r11.dropDownMenu[lst_r6 == null ? null : lst_r6.name]);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", lst_r6.functionLink && !ctx_r11.dropDownMenu[lst_r6 == null ? null : lst_r6.name]);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(5, 7, lst_r6.alternateName), ɵɵsanitizeHtml);
} }
function SidebarLeft_ng_container_6_ng_container_1_ng_container_1_list_queues_4_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "list-queues", 23);
    ɵɵlistener("response", function SidebarLeft_ng_container_6_ng_container_1_ng_container_1_list_queues_4_Template_list_queues_response_0_listener($event) { ɵɵrestoreView(_r20); const ctx_r19 = ɵɵnextContext(4); return ctx_r19.response_queue($event); })("enabledQueue", function SidebarLeft_ng_container_6_ng_container_1_ng_container_1_list_queues_4_Template_list_queues_enabledQueue_0_listener($event) { ɵɵrestoreView(_r20); const ctx_r21 = ɵɵnextContext(4); return ctx_r21.enabled_queue($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const lst_r6 = ɵɵnextContext(2).$implicit;
    const ctx_r12 = ɵɵnextContext(2);
    ɵɵclassProp("d-none", ctx_r12.dropDownMenu[lst_r6 == null ? null : lst_r6.name]);
    ɵɵproperty("functionLink", lst_r6.functionLink);
} }
function SidebarLeft_ng_container_6_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, SidebarLeft_ng_container_6_ng_container_1_ng_container_1_hr_1_Template, 1, 0, "hr", 10);
    ɵɵtemplate(2, SidebarLeft_ng_container_6_ng_container_1_ng_container_1_div_2_Template, 2, 0, "div", 11);
    ɵɵtemplate(3, SidebarLeft_ng_container_6_ng_container_1_ng_container_1_div_3_Template, 6, 12, "div", 12);
    ɵɵtemplate(4, SidebarLeft_ng_container_6_ng_container_1_ng_container_1_list_queues_4_Template, 1, 3, "list-queues", 13);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const lst_r6 = ɵɵnextContext().$implicit;
    const ctx_r7 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", lst_r6.functionLink && ctx_r7.enabledQueue);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", lst_r6.functionLink && ctx_r7.enabledQueue);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", lst_r6.functionLink && ctx_r7.enabledQueue || !lst_r6.functionLink);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", lst_r6.functionLink);
} }
function SidebarLeft_ng_container_6_ng_container_1_ng_container_2_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 30);
} }
function SidebarLeft_ng_container_6_ng_container_1_ng_container_2_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 31);
} }
const _c1 = function (a0) { return { "disabled": a0 }; };
function SidebarLeft_ng_container_6_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 24);
    ɵɵlistener("click", function SidebarLeft_ng_container_6_ng_container_1_ng_container_2_Template_div_click_1_listener() { ɵɵrestoreView(_r27); const ctx_r26 = ɵɵnextContext(3); return ctx_r26.closeMenu(); });
    ɵɵelementStart(2, "a", 25);
    ɵɵlistener("click", function SidebarLeft_ng_container_6_ng_container_1_ng_container_2_Template_a_click_2_listener() { ɵɵrestoreView(_r27); const lst_r6 = ɵɵnextContext().$implicit; const ctx_r28 = ɵɵnextContext(2); return (ctx_r28.dropDownMenu[lst_r6 == null ? null : lst_r6.name] = !ctx_r28.dropDownMenu[lst_r6 == null ? null : lst_r6.name]); });
    ɵɵtemplate(3, SidebarLeft_ng_container_6_ng_container_1_ng_container_2_i_3_Template, 1, 0, "i", 26);
    ɵɵtemplate(4, SidebarLeft_ng_container_6_ng_container_1_ng_container_2_i_4_Template, 1, 0, "i", 27);
    ɵɵelement(5, "i", 28);
    ɵɵelement(6, "span", 20);
    ɵɵpipe(7, "i18n");
    ɵɵelement(8, "i", 29);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const lst_r6 = ɵɵnextContext().$implicit;
    const ctx_r8 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵproperty("ngClass", ɵɵpureFunction1(7, _c1, lst_r6 == null ? null : lst_r6.disabled));
    ɵɵattribute("disabled", lst_r6 == null ? null : lst_r6.disabled);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r8.dropDownMenu[lst_r6 == null ? null : lst_r6.name]);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r8.dropDownMenu[lst_r6 == null ? null : lst_r6.name]);
    ɵɵadvance(2);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(7, 5, lst_r6.alternateName), ɵɵsanitizeHtml);
} }
function SidebarLeft_ng_container_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0, 9);
    ɵɵtemplate(1, SidebarLeft_ng_container_6_ng_container_1_ng_container_1_Template, 5, 4, "ng-container", 4);
    ɵɵtemplate(2, SidebarLeft_ng_container_6_ng_container_1_ng_container_2_Template, 9, 9, "ng-container", 4);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const lst_r6 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (lst_r6 == null ? null : lst_r6.dataFieldItemList == null ? null : lst_r6.dataFieldItemList.listItems == null ? null : lst_r6.dataFieldItemList.listItems.length) < 1);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (lst_r6 == null ? null : lst_r6.dataFieldItemList == null ? null : lst_r6.dataFieldItemList.listItems == null ? null : lst_r6.dataFieldItemList.listItems.length) > 0);
} }
function SidebarLeft_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, SidebarLeft_ng_container_6_ng_container_1_Template, 3, 2, "ng-container", 8);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r3.sidebarOptionsLeft);
} }
function SidebarLeft_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
class SidebarLeft {
    constructor(route, router, formBuilder, _sanitizer, _httpService, _akeelaSidebarMenu, _auth, _path, routeService, templateService, localStorage) {
        this.route = route;
        this.router = router;
        this.formBuilder = formBuilder;
        this._sanitizer = _sanitizer;
        this._httpService = _httpService;
        this._akeelaSidebarMenu = _akeelaSidebarMenu;
        this._auth = _auth;
        this._path = _path;
        this.routeService = routeService;
        this.templateService = templateService;
        this.localStorage = localStorage;
        this.response = new EventEmitter();
        this.dropDownMenu = {};
        this.sidebarLeftOptions = {};
        this.ulrLogout = '/';
        this.queryParams = {};
        this.templates = {};
        this.isAuth = false;
        this.enabledQueue = false;
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.templates = this.templateService.getTemplates();
        }, 10);
    }
    ngOnInit() {
        this._auth.isAuth$.subscribe((isAuth) => {
            if (isAuth !== this.isAuth) {
                if (!isAuth) {
                    if (this.isAuth) {
                        this.isAuth = isAuth;
                        // this.redirect(this.ulrLogout,{});
                        this._akeelaSidebarMenu.setshowSidebarLeft(false);
                        location.reload();
                    }
                    else {
                        this.isAuth = isAuth;
                    }
                }
                else {
                    this.isAuth = isAuth;
                }
            }
        });
        this._akeelaSidebarMenu.sidebarLeftActive$.subscribe((sidebarLeftActive) => {
            this.sidebarLeftActive = null;
            this.sidebarLeftActive = sidebarLeftActive;
        });
        if (!this.ulrImg) {
            this.ulrImg = 'http://akcredit.akeela.co/assets/public/images/akcredit_black.png';
        }
        this.route.queryParams.subscribe(queryparams => {
            this.queryParams = queryparams;
        });
        this._akeelaSidebarMenu.sidebarLeftKey$.subscribe(response => {
            this.sidebarOptionsLeft = null;
            if (!isNullOrUndefined(response)) {
                this.sidebarLeftOptions = this._akeelaSidebarMenu.sidebarLeftOptions$.getValue();
                let paramsData = this._path.getAdditionalType(this, response.additionalType);
                let params = {
                    configuration: {
                        name: response.name,
                        params: paramsData.params
                    }
                };
                this.subscriptor_menu = this._httpService.executeRequest(params.configuration.name, params.configuration.params, true).subscribe((params) => {
                    if (!this.sidebarLeftOptions.typeUser) {
                        this.sidebarOptionsLeft = params.listItems;
                    }
                    else {
                        this.sidebarOptionsLeft = params;
                    }
                }, (error) => {
                });
            }
        });
        this._akeelaSidebarMenu.showSidebarLeft$.subscribe((data) => {
            this.showSidebarLeft = data;
        });
    }
    response_queue(response) {
        this.response.emit(response);
    }
    processLink(data) {
        this.sidebarLeftActive = data.name;
        this._akeelaSidebarMenu.setSidebarLeftActive(this.sidebarLeftActive);
        this._akeelaSidebarMenu.setSidebarSubLeftActive(null);
        this._akeelaSidebarMenu.setSidebarTopActive(null);
        if (data.functionLink) {
            this.dropDownMenu[data.name] = !this.dropDownMenu[data.name];
        }
        this.dataproceslink = {};
        this.dataproceslink = data;
        this.role = this.localStorage.getItem('role');
        this.profile = this.localStorage.getItem('profile');
        this.audience = this.localStorage.getItem('audience');
        const url = '';
        const request = {};
        if (data.dynamicLink) {
            this.subscriptor_menu_click = this._httpService.executeFrontRequest(this, this.dataproceslink.dynamicLink, true).subscribe((response) => {
                if (!isNullOrUndefined(response)) {
                    this.response.emit({
                        action: 'navigate',
                        url: response.url
                    });
                    this.redirect(response.url, response.request);
                }
            });
        }
        else if (this.dataproceslink.functionLink) {
        }
        else if (this.dataproceslink.url) {
            this.response.emit({
                action: 'navigate',
                url: url
            });
            this.redirect(url, request);
        }
    }
    logout() {
        this._auth.logout();
    }
    closeMenu() {
        if (screen.width < 768) {
            this._akeelaSidebarMenu.setshowSidebarLeft(false);
        }
        else {
            this._akeelaSidebarMenu.setshowSidebarLeft(true);
        }
    }
    redirect(url, request) {
        this.localStorage.removeItem('top');
        const queryParams = request;
        this.router.navigate([url], { queryParams });
    }
    ngOnDestroy() {
        if (this.subscriptor_menu) {
            this.subscriptor_menu.unsubscribe();
        }
        if (this.subscriptor_menu_click) {
            this.subscriptor_menu_click.unsubscribe();
        }
        if (this.subscriptor_params) {
            this.subscriptor_params.unsubscribe();
        }
    }
    enabled_queue(active) {
        this.enabledQueue = active;
    }
}
/** @nocollapse */ SidebarLeft.ɵfac = function SidebarLeft_Factory(t) { return new (t || SidebarLeft)(ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(DomSanitizer), ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(AkeelaSidebarMenuService), ɵɵdirectiveInject(AuthService), ɵɵdirectiveInject(PathService), ɵɵdirectiveInject(RouteUtilsService), ɵɵdirectiveInject(AkeelaTemplateService), ɵɵdirectiveInject(LocalService)); };
/** @nocollapse */ SidebarLeft.ɵcmp = ɵɵdefineComponent({ type: SidebarLeft, selectors: [["akeela-sidebarLeft"]], inputs: { ulrImg: "ulrImg", ulrLogout: "ulrLogout" }, outputs: { response: "response" }, decls: 11, vars: 5, consts: [[1, "sidebar", "pr-2"], [1, "w-100", "head", "col-12", "animate__animated", "animate__fadeIn", "pl-1", "pr-1"], [4, "ngTemplateOutlet"], [1, "col-12", "bg-body", "animate__animated", "animate__fadeIn", "pl-1", "pr-1"], [4, "ngIf"], [1, "w-100", "animate__animated", "animate__fadeIn", "mt-2"], [1, "row"], ["src", "./assets/public/images/loading.gif", "alt", " "], ["class", " animate__animated animate__fadeIn", 4, "ngFor", "ngForOf"], [1, "animate__animated", "animate__fadeIn"], ["class", "mt-2 mb-1", 4, "ngIf"], ["class", " category font-weight-bold", 4, "ngIf"], ["class", "principal dd-link cursor-pounter", 3, "active", "click", 4, "ngIf"], [3, "d-none", "functionLink", "response", "enabledQueue", 4, "ngIf"], [1, "mt-2", "mb-1"], [1, "category", "font-weight-bold"], [1, "principal", "dd-link", "cursor-pounter", 3, "click"], ["href", "javascript:void(0) ", 3, "ngClass"], ["class", "text-secondary fa fa-angle-down  pr-1", 4, "ngIf"], ["class", "text-secondary fa fa-angle-up  pr-1", 4, "ngIf"], [3, "innerHTML"], [1, "text-secondary", "fa", "fa-angle-down", "pr-1"], [1, "text-secondary", "fa", "fa-angle-up", "pr-1"], [3, "functionLink", "response", "enabledQueue"], [1, "dd-link", 3, "click"], ["href", "javascript:void(0)", 1, "text-white", 3, "ngClass", "click"], ["class", "fa fa-angle-down float-right mt-1 ", 4, "ngIf"], ["class", "fa fa-angle-up float-right mt-1", 4, "ngIf"], ["aria-hidden", "true", 1, "fas", "fa-chart-line", "icon-menu"], [1, "fas", "fa-angle-right", "mt-1", "float-right"], [1, "fa", "fa-angle-down", "float-right", "mt-1"], [1, "fa", "fa-angle-up", "float-right", "mt-1"]], template: function SidebarLeft_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵtemplate(2, SidebarLeft_ng_container_2_Template, 1, 0, "ng-container", 2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "div", 3);
        ɵɵtemplate(4, SidebarLeft_ng_container_4_Template, 1, 0, "ng-container", 2);
        ɵɵtemplate(5, SidebarLeft_ng_container_5_Template, 3, 0, "ng-container", 4);
        ɵɵtemplate(6, SidebarLeft_ng_container_6_Template, 2, 1, "ng-container", 4);
        ɵɵelementEnd();
        ɵɵelementStart(7, "div", 5);
        ɵɵelement(8, "hr");
        ɵɵtemplate(9, SidebarLeft_ng_container_9_Template, 1, 0, "ng-container", 2);
        ɵɵelementEnd();
        ɵɵelement(10, "br");
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵproperty("ngTemplateOutlet", ctx.templates["menuHeader"]);
        ɵɵadvance(2);
        ɵɵproperty("ngTemplateOutlet", ctx.templates["menuBody"]);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.sidebarOptionsLeft);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.sidebarOptionsLeft);
        ɵɵadvance(3);
        ɵɵproperty("ngTemplateOutlet", ctx.templates["menuFooter"]);
    } }, directives: [NgTemplateOutlet, NgIf, NgForOf, NgClass, ListQueues], pipes: [I18nPipe], styles: ["[_nghost-%COMP%]{--ak-menu-left-bg:#f3f3f3;--ak-menu-left-border:1px solid #ccc;--ak-menu-left-dd-link:#555;--ak-menu-left-dd-link-bg-hover:transparent;--ak-menu-left-dd-link-hover:#333;--ak-menu-left-head-bg:#f3f3f3}.sidebar[_ngcontent-%COMP%]{background-color:var(--ak-menu-left-bg);border:var(--ak-menu-left-border);bottom:0;box-shadow:-2px 0 10px -4px #444;font-size:16px;left:0;max-width:230px;min-width:230px;overflow:hidden;position:fixed;right:auto;top:0;z-index:3}.sidebar[_ngcontent-%COMP%]:hover{overflow-y:auto}.sidebar[_ngcontent-%COMP%]   .bg-body[_ngcontent-%COMP%]{background-color:var(--ak-menu-left-bg);margin-top:70px;min-height:435px;z-index:1}.navbar-default[_ngcontent-%COMP%]   .navbar-brand[_ngcontent-%COMP%]{color:#fff}@media (max-width:768px){.sidebar[_ngcontent-%COMP%]{max-width:280px;min-width:280px;overflow-y:auto!important}}.sidebar[_ngcontent-%COMP%]{height:100%;width:100%}.sidebar[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{font-size:18px;font-weight:400;line-height:3;list-style:none;padding-top:50px}.sidebar[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{cursor:pointer;text-decoration:none}.sidebar[_ngcontent-%COMP%]   .m-l-title[_ngcontent-%COMP%]{font-size:18px;font-weight:700}.sidebar[_ngcontent-%COMP%]   .m-l-subTitle[_ngcontent-%COMP%]{color:#777!important;font-size:16px;font-weight:700}.sidebar[_ngcontent-%COMP%]   .cerrar[_ngcontent-%COMP%]{color:#777;font-size:20px;margin:8px 8px 0}.sidebar[_ngcontent-%COMP%]   .cerrar[_ngcontent-%COMP%]:HOVER{color:#aaa}.sidebar[_ngcontent-%COMP%]   .head[_ngcontent-%COMP%]{background-color:var(--ak-menu-left-head-bg);min-height:69px;padding-top:1rem;position:fixed;width:228px!important;z-index:2}.sidebar[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]{background-color:var(--ak-menu-left-footer-bg);bottom:0;margin-bottom:0;margin-top:10px}.sidebar[_ngcontent-%COMP%]   .head[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{margin-top:1rem}.sidebar[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]{font-size:16px;margin-top:35px;padding-left:8px;padding-right:8px}.sidebar[_ngcontent-%COMP%]   hr.separador.claro[_ngcontent-%COMP%]{border-top:1px solid #ddd}.sidebar[_ngcontent-%COMP%]   .icon-dropdown[_ngcontent-%COMP%]{font-size:24px}.sidebar[_ngcontent-%COMP%]   .sidebar-dropdown[_ngcontent-%COMP%]{margin-bottom:5px;padding:3px 0}.sidebar[_ngcontent-%COMP%]   .dd-link[_ngcontent-%COMP%]{font-size:14px;margin-bottom:0;margin-top:0;padding:8px 5px 8px 15px}.sidebar[_ngcontent-%COMP%]   .dd-link.active[_ngcontent-%COMP%], .sidebar[_ngcontent-%COMP%]   .dd-link[_ngcontent-%COMP%]:hover{background:var(--ak-menu-left-dd-link-bg-hover)!important;border-radius:6px}.sidebar[_ngcontent-%COMP%]   .dd-link[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:var(--ak-menu-left-dd-link)!important}.sidebar[_ngcontent-%COMP%]   .dd-link.active[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .sidebar[_ngcontent-%COMP%]   .dd-link.active[_ngcontent-%COMP%]   i[_ngcontent-%COMP%], .sidebar[_ngcontent-%COMP%]   .dd-link[_ngcontent-%COMP%]:hover   a[_ngcontent-%COMP%]{color:var(--ak-menu-left-dd-link-hover)!important}.sidebar[_ngcontent-%COMP%]   .dd-link[_ngcontent-%COMP%]:hover   a.disabled[_ngcontent-%COMP%], .sidebar[_ngcontent-%COMP%]   .dd-link[_ngcontent-%COMP%]   a.disabled[_ngcontent-%COMP%]{color:#bbb!important;cursor:default;padding:5px 0 8px;pointer-events:none}.sidebar[_ngcontent-%COMP%]   .title-sidebar[_ngcontent-%COMP%]{border-bottom:.5px solid #aaa;border-top:.5px solid #aaa}.sidebar[_ngcontent-%COMP%]   .dd-link2[_ngcontent-%COMP%]{padding:3px 0}.m-t-12[_ngcontent-%COMP%]{margin-top:23px}.sidebar[_ngcontent-%COMP%]::-webkit-scrollbar{border-radius:50px;height:5px!important;width:5px!important}.pt-img[_ngcontent-%COMP%]{padding-left:15px;padding-top:16px;text-align:left}.icon-menu[_ngcontent-%COMP%]{font-size:1.2rem;margin-right:.8rem}.sub-menu[_ngcontent-%COMP%]{margin-bottom:.7rem;margin-left:2.4rem}.category[_ngcontent-%COMP%]{color:#999;font-size:16px;margin-top:0;padding-bottom:13px;padding-left:0;padding-top:5px}@media (max-width:768px){.category[_ngcontent-%COMP%], .sidebar[_ngcontent-%COMP%], .sidebar[_ngcontent-%COMP%]   .dd-link[_ngcontent-%COMP%]{font-size:16px}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SidebarLeft, [{
        type: Component,
        args: [{
                selector: 'akeela-sidebarLeft',
                templateUrl: './sidebarLeft.component.html',
                styleUrls: ['./sidebarLeft.component.css']
            }]
    }], function () { return [{ type: ActivatedRoute }, { type: Router }, { type: FormBuilder }, { type: DomSanitizer }, { type: HttpService }, { type: AkeelaSidebarMenuService }, { type: AuthService }, { type: PathService }, { type: RouteUtilsService }, { type: AkeelaTemplateService }, { type: LocalService }]; }, { response: [{
            type: Output
        }], ulrImg: [{
            type: Input
        }], ulrLogout: [{
            type: Input
        }] }); })();

const _c0$1 = function (a0) { return { "active": a0 }; };
const _c1$1 = function (a0) { return { "disabled": a0 }; };
function SidebarTop_ng_container_3_ng_container_3_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "li", 7);
    ɵɵelementStart(1, "a", 8);
    ɵɵlistener("click", function SidebarTop_ng_container_3_ng_container_3_li_1_Template_a_click_1_listener() { ɵɵrestoreView(_r7); const lst_r2 = ɵɵnextContext().$implicit; const ctx_r5 = ɵɵnextContext(2); return (lst_r2 == null ? null : lst_r2.name) === "EXIT" ? ctx_r5.logout() : ctx_r5.processLink(lst_r2); });
    ɵɵelement(2, "span", 9);
    ɵɵpipe(3, "i18n");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const lst_r2 = ɵɵnextContext().$implicit;
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵproperty("ngClass", ɵɵpureFunction1(6, _c0$1, ctx_r3.sidebarTopActive == lst_r2.name));
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ɵɵpureFunction1(8, _c1$1, lst_r2 == null ? null : lst_r2.disabled));
    ɵɵattribute("disabled", lst_r2 == null ? null : lst_r2.disabled);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 4, lst_r2.alternateName), ɵɵsanitizeHtml);
} }
const _c2 = function (a0, a1) { return { "disabled": a0, "active": a1 }; };
function SidebarTop_ng_container_3_ng_container_3_ng_container_2_li_6_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "li");
    ɵɵelementStart(1, "a", 13);
    ɵɵlistener("click", function SidebarTop_ng_container_3_ng_container_3_ng_container_2_li_6_Template_a_click_1_listener() { ɵɵrestoreView(_r12); const option_r10 = ctx.$implicit; const lst_r2 = ɵɵnextContext(2).$implicit; const ctx_r11 = ɵɵnextContext(2); return (option_r10 == null ? null : option_r10.name) === "EXIT" ? ctx_r11.logout() : ctx_r11.processLink(option_r10, lst_r2); });
    ɵɵelement(2, "span", 9);
    ɵɵpipe(3, "i18n");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const option_r10 = ctx.$implicit;
    const ctx_r9 = ɵɵnextContext(4);
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ɵɵpureFunction2(5, _c2, option_r10 == null ? null : option_r10.disabled, ctx_r9.sidebar2TopActive == option_r10.name));
    ɵɵattribute("disabled", option_r10 == null ? null : option_r10.disabled);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 3, option_r10.alternateName), ɵɵsanitizeHtml);
} }
function SidebarTop_ng_container_3_ng_container_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "li", 10);
    ɵɵelementStart(2, "a", 11);
    ɵɵtext(3);
    ɵɵpipe(4, "i18n");
    ɵɵelementEnd();
    ɵɵelementStart(5, "ul", 12);
    ɵɵtemplate(6, SidebarTop_ng_container_3_ng_container_3_ng_container_2_li_6_Template, 4, 8, "li", 5);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const lst_r2 = ɵɵnextContext().$implicit;
    const ctx_r4 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ɵɵpureFunction1(5, _c0$1, ctx_r4.sidebarTopActive == lst_r2.name));
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(4, 3, lst_r2.alternateName), " ");
    ɵɵadvance(3);
    ɵɵproperty("ngForOf", lst_r2 == null ? null : lst_r2.dataFieldItemList == null ? null : lst_r2.dataFieldItemList.listItems);
} }
function SidebarTop_ng_container_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, SidebarTop_ng_container_3_ng_container_3_li_1_Template, 4, 10, "li", 6);
    ɵɵtemplate(2, SidebarTop_ng_container_3_ng_container_3_ng_container_2_Template, 7, 7, "ng-container", 2);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const lst_r2 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (lst_r2 == null ? null : lst_r2.dataFieldItemList == null ? null : lst_r2.dataFieldItemList.listItems == null ? null : lst_r2.dataFieldItemList.listItems.length) === 0);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (lst_r2 == null ? null : lst_r2.dataFieldItemList == null ? null : lst_r2.dataFieldItemList.listItems == null ? null : lst_r2.dataFieldItemList.listItems.length) > 0);
} }
function SidebarTop_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 3);
    ɵɵelementStart(2, "ul", 4);
    ɵɵtemplate(3, SidebarTop_ng_container_3_ng_container_3_Template, 3, 2, "ng-container", 5);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵproperty("ngForOf", ctx_r0.sidebarOptionsTop);
} }
class SidebarTop {
    constructor(route, router, formBuilder, _sanitizer, _httpService, _akeelaSidebarMenu, _auth, _path, routeService, templateService, localStorage) {
        this.route = route;
        this.router = router;
        this.formBuilder = formBuilder;
        this._sanitizer = _sanitizer;
        this._httpService = _httpService;
        this._akeelaSidebarMenu = _akeelaSidebarMenu;
        this._auth = _auth;
        this._path = _path;
        this.routeService = routeService;
        this.templateService = templateService;
        this.localStorage = localStorage;
        this.response = new EventEmitter();
        this.dropDownMenu = {};
        this.sidebarTopOptions = {};
        this.ulrLogout = '/';
        this.queryParams = {};
        this.templates = {};
        this.isAuth = false;
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.templates = this.templateService.getTemplates();
        }, 10);
    }
    ngOnInit() {
        this._auth.isAuth$.subscribe((isAuth) => {
            if (isAuth !== this.isAuth) {
                if (!isAuth) {
                    if (this.isAuth) {
                        this.isAuth = isAuth;
                        // this.redirect(this.ulrLogout,{});
                        this._akeelaSidebarMenu.setshowSidebarTop(false);
                        location.reload();
                    }
                    else {
                        this.isAuth = isAuth;
                    }
                }
                else {
                    this.isAuth = isAuth;
                }
            }
        });
        this._akeelaSidebarMenu.sidebarTopActive$.subscribe((data) => {
            if (data) {
                this.sidebarTopActive = data.sidebarTopActive ? data.sidebarTopActive : '';
                this.sidebar2TopActive = data.sidebar2TopActive ? data.sidebar2TopActive : '';
            }
        });
        if (!this.ulrImg) {
            this.ulrImg = 'http://akcredit.akeela.co/assets/public/images/akcredit_black.png';
        }
        this.route.queryParams.subscribe(queryparams => {
            this.queryParams = queryparams;
        });
        this._akeelaSidebarMenu.sidebarTopKey$.subscribe(response => {
            this.sidebarOptionsTop = null;
            if (!isNullOrUndefined(response)) {
                this.sidebarTopOptions = this._akeelaSidebarMenu.sidebarTopOptions$.getValue();
                let paramsData = this._path.getAdditionalType(this, response.additionalType);
                let params = {
                    configuration: {
                        name: response.name,
                        params: paramsData.params
                    }
                };
                this.subscriptor_menu = this._httpService.executeRequest(params.configuration.name, params.configuration.params, true).subscribe((params) => {
                    if (!this.sidebarTopOptions.typeUser) {
                        this.sidebarOptionsTop = params.listItems;
                    }
                    else {
                        this.sidebarOptionsTop = params;
                    }
                }, (error) => {
                });
            }
        });
        this._akeelaSidebarMenu.showSidebarTop$.subscribe((data) => {
            this.showSidebarTop = data;
        });
    }
    processLink(data, data2 = false) {
        if (data2) {
            this.sidebarTopActive = data2.name;
            this.sidebar2TopActive = data.name;
        }
        else {
            this.sidebarTopActive = data.name;
        }
        this._akeelaSidebarMenu.setSidebarTopActive({ 'sidebarTopActive': this.sidebarTopActive, 'sidebar2TopActive': this.sidebar2TopActive });
        this._akeelaSidebarMenu.setSidebarSubLeftActive(null);
        this._akeelaSidebarMenu.setSidebarLeftActive(null);
        this.dataproceslink = {};
        this.dataproceslink = data;
        this.role = this.localStorage.getItem('role');
        this.profile = this.localStorage.getItem('profile');
        this.audience = this.localStorage.getItem('audience');
        const url = '';
        const request = {};
        if (data.dynamicLink) {
            this.subscriptor_menu_click = this._httpService.executeFrontRequest(this, this.dataproceslink.dynamicLink, true).subscribe((response) => {
                if (!isNullOrUndefined(response)) {
                    this.response.emit({
                        action: 'navigate',
                        url: response.url
                    });
                    this.redirect(response.url, response.request);
                }
            });
        }
        else if (this.dataproceslink.functionLink) {
        }
        else if (this.dataproceslink.url) {
            this.response.emit({
                action: 'navigate',
                url: url
            });
            this.redirect(url, request);
        }
    }
    logout() {
        this._auth.logout();
    }
    closeMenu() {
        if (screen.width < 768) {
            this._akeelaSidebarMenu.setshowSidebarTop(false);
        }
        else {
            this._akeelaSidebarMenu.setshowSidebarTop(true);
        }
    }
    redirect(url, request) {
        this.localStorage.setItem('top', true);
        const queryParams = request;
        this.router.navigate([url], { queryParams });
    }
    ngOnDestroy() {
        if (this.subscriptor_menu) {
            this.subscriptor_menu.unsubscribe();
        }
        if (this.subscriptor_menu_click) {
            this.subscriptor_menu_click.unsubscribe();
        }
        if (this.subscriptor_params) {
            this.subscriptor_params.unsubscribe();
        }
    }
}
/** @nocollapse */ SidebarTop.ɵfac = function SidebarTop_Factory(t) { return new (t || SidebarTop)(ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(DomSanitizer), ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(AkeelaSidebarMenuService), ɵɵdirectiveInject(AuthService), ɵɵdirectiveInject(PathService), ɵɵdirectiveInject(RouteUtilsService), ɵɵdirectiveInject(AkeelaTemplateService), ɵɵdirectiveInject(LocalService)); };
/** @nocollapse */ SidebarTop.ɵcmp = ɵɵdefineComponent({ type: SidebarTop, selectors: [["akeela-sidebarTop"]], inputs: { ulrImg: "ulrImg", ulrLogout: "ulrLogout" }, outputs: { response: "response" }, decls: 4, vars: 1, consts: [[1, "sidebar", "top"], [1, "navbar", "navbar-expand-lg", "bg-white", "navbar-light", "pl-0", "pr-0"], [4, "ngIf"], ["id", "navbarNavDropdown", 1, ""], [1, "navbar-nav"], [4, "ngFor", "ngForOf"], [3, "ngClass", 4, "ngIf"], [3, "ngClass"], ["href", "javascript:void(0) ", 1, "nav-link", "disabled", 3, "ngClass", "click"], [3, "innerHTML"], [1, "nav-item", "dropdown", 3, "ngClass"], ["href", "#", "id", "navbarDropdownMenuLink", "role", "button", "data-toggle", "dropdown", "aria-haspopup", "true", "aria-expanded", "false", 1, "nav-link", "dropdown-toggle"], ["aria-labelledby", "navbarDropdownMenuLink", 1, "dropdown-menu"], ["href", "javascript:void(0) ", 1, "dropdown-item", "item2", 3, "ngClass", "click"]], template: function SidebarTop_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div");
        ɵɵelementStart(2, "nav", 1);
        ɵɵtemplate(3, SidebarTop_ng_container_3_Template, 4, 1, "ng-container", 2);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.sidebarOptionsTop);
    } }, directives: [NgIf, NgForOf, NgClass], pipes: [I18nPipe], styles: ["[_nghost-%COMP%]{--ak-menu-top:#555;--ak-menu-top-bg:#f3f3f3;--ak-menu-top-border:1px solid #ccc;--ak-menu-top-disabled:#ccc;--ak-menu-top-hover:#333;--ak-menu-top2:#666;--ak-menu-top2-hover:#333}.navbar[_ngcontent-%COMP%]{background:var(--ak-menu-top-bg)!important}.navbar-nav[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:not(.item2){color:var(--ak-menu-top);font-size:1rem}.navbar-nav[_ngcontent-%COMP%]   a.item2[_ngcontent-%COMP%]{color:var(--ak-menu-top2)!important}.navbar-nav[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:var(--ak-menu-top-hover)!important}.navbar-nav[_ngcontent-%COMP%]   a.disabled[_ngcontent-%COMP%]{color:var(--ak-menu-top-disabled)!important}.dropdown-item.active[_ngcontent-%COMP%], .dropdown-item[_ngcontent-%COMP%]:active{background-color:#ddd}.navbar-nav[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%]   a.item2[_ngcontent-%COMP%], .navbar-nav[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover   a.item2[_ngcontent-%COMP%]{color:var(--ak-menu-top2-hover)!important}.navbar-nav[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:not(.item2), .navbar-nav[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover   a[_ngcontent-%COMP%]:not(.item2){color:var(--ak-menu-top-hover)!important}.sidebar[_ngcontent-%COMP%]{padding-left:2rem}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SidebarTop, [{
        type: Component,
        args: [{
                selector: 'akeela-sidebarTop',
                templateUrl: './sidebarTop.component.html',
                styleUrls: ['./sidebarTop.component.css']
            }]
    }], function () { return [{ type: ActivatedRoute }, { type: Router }, { type: FormBuilder }, { type: DomSanitizer }, { type: HttpService }, { type: AkeelaSidebarMenuService }, { type: AuthService }, { type: PathService }, { type: RouteUtilsService }, { type: AkeelaTemplateService }, { type: LocalService }]; }, { response: [{
            type: Output
        }], ulrImg: [{
            type: Input
        }], ulrLogout: [{
            type: Input
        }] }); })();

class ContentDirective {
    constructor() {
    }
}
/** @nocollapse */ ContentDirective.ɵfac = function ContentDirective_Factory(t) { return new (t || ContentDirective)(); };
/** @nocollapse */ ContentDirective.ɵdir = ɵɵdefineDirective({ type: ContentDirective, selectors: [["", "sd-akeela-content", ""]], inputs: { componentName: "componentName" } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ContentDirective, [{
        type: Directive,
        args: [{
                selector: '[sd-akeela-content]'
            }]
    }], function () { return []; }, { componentName: [{
            type: Input
        }] }); })();

class AkeelaTemplateComponent {
    constructor(templateService) {
        this.templateService = templateService;
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.contentsRef.forEach((item, index) => {
                const template = this.templatesRef.find((_template, templateIndex) => templateIndex === index);
                this.templateService.addTemplate(item.componentName, template);
            });
        }, 10);
    }
}
/** @nocollapse */ AkeelaTemplateComponent.ɵfac = function AkeelaTemplateComponent_Factory(t) { return new (t || AkeelaTemplateComponent)(ɵɵdirectiveInject(AkeelaTemplateService)); };
/** @nocollapse */ AkeelaTemplateComponent.ɵcmp = ɵɵdefineComponent({ type: AkeelaTemplateComponent, selectors: [["sd-akeela-template"]], contentQueries: function AkeelaTemplateComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵɵcontentQuery(dirIndex, ContentDirective, false);
        ɵɵcontentQuery(dirIndex, ContentDirective, false, TemplateRef);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.contentsRef = _t);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.templatesRef = _t);
    } }, decls: 1, vars: 0, template: function AkeelaTemplateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementContainer(0);
    } }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaTemplateComponent, [{
        type: Component,
        args: [{
                selector: 'sd-akeela-template',
                templateUrl: './akeela-template.component.html',
                styleUrls: ['./akeela-template.component.css']
            }]
    }], function () { return [{ type: AkeelaTemplateService }]; }, { contentsRef: [{
            type: ContentChildren,
            args: [ContentDirective]
        }], templatesRef: [{
            type: ContentChildren,
            args: [ContentDirective, { read: TemplateRef }]
        }] }); })();

class AkeelaMenuModule {
}
/** @nocollapse */ AkeelaMenuModule.ɵmod = ɵɵdefineNgModule({ type: AkeelaMenuModule });
/** @nocollapse */ AkeelaMenuModule.ɵinj = ɵɵdefineInjector({ factory: function AkeelaMenuModule_Factory(t) { return new (t || AkeelaMenuModule)(); }, providers: [AkeelaSidebarMenuService, AkeelaTemplateService
    ], imports: [[
            CommonModule,
            I18nModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(AkeelaMenuModule, { declarations: [ListQueues, SidebarTop, SidebarLeft, AkeelaTemplateComponent, ContentDirective], imports: [CommonModule,
        I18nModule], exports: [SidebarLeft, SidebarTop, AkeelaTemplateComponent, ContentDirective] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaMenuModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    I18nModule
                ],
                declarations: [ListQueues, SidebarTop, SidebarLeft, AkeelaTemplateComponent, ContentDirective
                ],
                providers: [AkeelaSidebarMenuService, AkeelaTemplateService
                ],
                exports: [SidebarLeft, SidebarTop, AkeelaTemplateComponent, ContentDirective]
            }]
    }], null, null); })();

/*
 * Public API Surface of akeela-security
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AkeelaMenuModule, AkeelaSidebarMenuService, AkeelaTemplateComponent, AkeelaTemplateService, ContentDirective, SidebarLeft, SidebarTop };
//# sourceMappingURL=akeela-menu.js.map
